import { Box, Typography, Button, styled } from "@mui/material";
import colors from "../../../theme/Colours";

const MIDDLE_H = 180; // cream layer height inpx
const BOTTOM_H = 120; // bottom teal strip height in px

export const AboutUsWrapper = styled(Box)({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  background: `linear-gradient(
    to bottom,
    ${colors.homepageTealBG} calc(100% - ${MIDDLE_H + BOTTOM_H}px),
    ${colors.homepageNudeBG} calc(100% - ${MIDDLE_H + BOTTOM_H}px),
    ${colors.homepageNudeBG} calc(100% - ${BOTTOM_H}px),
    ${colors.homepageTealBG} calc(100% - ${BOTTOM_H}px)
  )`,
  "@media (max-width: 768px)": {
    flexDirection: "column",
  },
});

/* Left column */
export const ImagesColumn = styled(Box)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  flexShrink: 0,
  width: "42%",
  gap: "20px",
  padding: "70px 0 32px 28px",
  "@media (max-width: 960px)": {
    padding: "70px 0 32px 16px",
  },
  "@media (max-width: 768px)": {
    width: "100%",
    padding: "70px 32px 0 12px",
    height: "260px",
  },
});

export const ImageLeft = styled("img")({
  width: "50%",
  height: "90%",
  objectFit: "cover",
  display: "block",
});

export const ImageRight = styled("img")({
  width: "50%",
  height: "90%",
  objectFit: "cover",
  display: "block",
});

/* Right column */
export const RightColumn = styled(Box)({
  flex: 1,
  display: "flex",
  flexDirection: "column",
});

/** Layer 1: teal  */
export const TopLayer = styled(Box)({
  background: colors.homepageTealBG,
  flex: 1,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: "64px 48px 150px 48px",
  "@media (max-width: 960px)": {
    padding: "64px 24px 180px 24px",
  },
});

export const AboutUsSubtitle = styled(Typography)({
  fontFamily: "DM Sans, sans-serif",
  fontWeight: 400,
  fontSize: "64px",
  color: colors.background2,
  marginBottom: "12px",
  letterSpacing: "3px",
  lineHeight: 1,
  "@media (max-width: 768px)": {
    fontSize: "48px",
  },
});

export const AboutUsDescription = styled(Typography)({
  fontFamily: "DM Sans, sans-serif",
  fontSize: "18px",
  lineHeight: 1.5,
  marginBottom: "18px",
  color: colors.background2,
});

export const ExploreButton = styled(Button)({
  background: colors.primaryButtonOrange,
  color: colors.background2,
  padding: "6px 22px",
  textTransform: "none",
  fontWeight: 400,
  letterSpacing: "1px",
  fontFamily: "Poppins, sans-serif",
  fontSize: "16px",
  borderRadius: "4px",
  width: "200px",
  height: "40px",
  alignSelf: "flex-start",
  "&:hover": {
    background: colors.hoverRed,
  },
});

/** Layer 2: cream */
export const MiddleLayer = styled(Box)({
  background: colors.homepageNudeBG,
  flexShrink: 0,
  height: `${MIDDLE_H}px`,
  display: "flex",
  alignItems: "center",
  padding: "0 48px",
  "@media (max-width: 960px)": {
    padding: "0 24px",
    height: "auto",
    minHeight: `${MIDDLE_H}px`,
  },
});

export const StaticText = styled(Typography)({
  fontFamily: "DM Sans, sans-serif",
  color: colors.primaryButtonOrange,
  fontSize: "18px",
  lineHeight: 1.5,
});

/** Layer 3: teal */
export const BottomLayer = styled(Box)({
  background: colors.homepageTealBG,
  flexShrink: 0,
  height: `${BOTTOM_H}px`,
});
